'use client';

import React from 'react';
import Collection, { CollectionProps } from 'components/commercetools-ui/organisms/product/collection';
import { TasticProps } from 'frontastic/tastics/types';

const CollectionTastic = ({ data }: TasticProps<CollectionProps>) => {
    console.log("data", data?.data?.dataSource);
    
    return <Collection data={data?.data?.dataSource} image={undefined} card_title={''} />;
};

export default CollectionTastic;
